var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPause = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38476 16H3.64438C4.55784 16 5.02899 15.5288 5.02899 14.6154V1.38462C5.02899 0.451923 4.55784 0.00961538 3.64438 0H1.38476C0.471298 0 0.00014426 0.471154 0.00014426 1.38462V14.6154C-0.00947112 15.5288 0.461683 16 1.38476 16ZM8.36538 16H10.6154C11.5288 16 12 15.5288 12 14.6154V1.38462C12 0.451923 11.5288 0 10.6154 0H8.36538C7.44231 0 6.98077 0.471154 6.98077 1.38462V14.6154C6.98077 15.5288 7.44231 16 8.36538 16Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPause);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-pause.88b32c8cd7cf0aa482702eda1e8577f1.svg";